module.exports = "{\n  \"plugins\": {\n    \"@brightinteractive/bright-js-framework/plugins/graphql\": {\n      \"backendUrl\": \"$MY_GRAPHQL_BACKEND\"\n    }\n  }\n}\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!../examples/graphql-client-with-external-api/luminant.json
// module id = 155
// module chunks = 77055595419222 249879837935775